<div class="login-wrapper">

  <!-- Panneau gauche — branding -->
  <div class="brand-panel">
    <div class="brand-content">
      <div class="brand-logo">
        <span class="brand-monogram">B</span>
      </div>
      <h1 class="brand-name">Bitha</h1>
      <p class="brand-tagline">Plateforme d'administration immobilière</p>

      <ul class="brand-features">
        <li>
          <span class="feat-icon"><i class="pi pi-building"></i></span>
          <span>Gestion des biens immobiliers</span>
        </li>
        <li>
          <span class="feat-icon"><i class="pi pi-file"></i></span>
          <span>Validation des documents</span>
        </li>
        <li>
          <span class="feat-icon"><i class="pi pi-crown"></i></span>
          <span>Pilotage des plans &amp; abonnements</span>
        </li>
        <li>
          <span class="feat-icon"><i class="pi pi-bell"></i></span>
          <span>Notifications en temps réel</span>
        </li>
      </ul>
    </div>

    <p class="brand-footer">© {{ year }} Bitha — Espace réservé aux administrateurs</p>
  </div>

  <!-- Panneau droit — formulaire -->
  <div class="form-panel">
    <div class="form-inner">
      <div class="form-header">
        <h2>Bon retour 👋</h2>
        <p>Connectez-vous à votre espace d'administration</p>
      </div>

      <form [formGroup]="form" (ngSubmit)="submit()" class="login-form">

        @if (error()) {
          <div class="error-banner">
            <i class="pi pi-exclamation-circle"></i>
            {{ error() }}
          </div>
        }

        <div class="field-group">
          <label class="field-label" for="email">Adresse email</label>
          <span class="field-input-wrap">
            <i class="pi pi-at field-icon"></i>
            <input pInputText id="email" type="email" formControlName="email"
                   placeholder="admin@bitha.ci" autocomplete="email" class="full-width email-input">
          </span>
          @if (form.get('email')?.touched && form.get('email')?.hasError('required')) {
            <p class="field-error">L'email est requis</p>
          }
          @if (form.get('email')?.touched && form.get('email')?.hasError('email')) {
            <p class="field-error">Adresse email invalide</p>
          }
        </div>

        <div class="field-group">
          <label class="field-label" for="password">Mot de passe</label>
          <p-password id="password" formControlName="password" [feedback]="false"
                      [toggleMask]="true" autocomplete="current-password"
                      placeholder="••••••••" styleClass="full-width" inputStyleClass="full-width" />
          @if (form.get('password')?.touched && form.get('password')?.hasError('required')) {
            <p class="field-error">Le mot de passe est requis</p>
          }
        </div>

        <button pButton type="submit" class="submit-btn" [disabled]="!form.valid || loading()" [loading]="loading()">
          @if (!loading()) {
            <i class="pi pi-lock-open"></i>
          }
          <span>{{ loading() ? 'Connexion en cours...' : 'Accéder au back office' }}</span>
        </button>

      </form>

      <p class="secure-note">
        <i class="pi pi-shield"></i>
        Connexion sécurisée — accès restreint aux administrateurs
      </p>
    </div>
  </div>

</div>
